/**
 * Section-based field visibility, validation, and payload fallbacks for Articles.
 * Keys are normalized section names (trim + lowercase).
 */

export const DEFAULT_SECTION_RULES = {
  hiddenFields: [],
  requiredFields: [],
  defaultValues: {},
};

/** Fallbacks applied to hidden fields when not overridden per section. */
export const HIDDEN_FIELD_FALLBACK_DEFAULTS = {
  detailPageUrl: "",
  eventLocation: "",
  authorName: "",
  sourceName: "",
  readingTime: "",
  eventsFrom: "",
  eventsTo: "",
  publishedOn: "",
  subSectionId: "",
  articleTag: "",
};

export const ARTICLE_SECTION_RULES = {
  "energy intelligence": {
    hiddenFields: [
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["articleTag", "contentImage", "bannerImage"],
    defaultValues: {
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
  "middle east war": {
    hiddenFields: [
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["articleTag", "contentImage", "bannerImage"],
    defaultValues: {
      authorName: "",
      sourceName: "",
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
  "energy & career events": {
    hiddenFields: [],
    requiredFields: [
      "eventsFrom",
      "eventsTo",
      "eventLocation",
      "contentImage",
      "bannerImage",
    ],
    defaultValues: {
      detailPageUrl: "",
      authorName: "",
      sourceName: "",
    },
  },
  "editor's pick": {
    hiddenFields: [
      "subSectionId",
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["articleTag", "contentImage", "bannerImage"],
    defaultValues: {
      subSectionId: "",
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
  "intelligence grid": {
    hiddenFields: [
      "subSectionId",
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["articleTag", "contentImage", "bannerImage"],
    defaultValues: {
      subSectionId: "",
      sourceName: "",
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
  "insights & briefings": {
    hiddenFields: [
      "contentImage",
      "subSectionId",
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["articleTag", "bannerImage"],
    defaultValues: {
      subSectionId: "",
      sourceName: "",
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
  "banner section": {
    hiddenFields: [
      "eventsFrom",
      "eventsTo",
      "eventLocation",
    ],
    requiredFields: ["contentImage", "bannerImage"],
    defaultValues: {
      authorName: "",
      sourceName: "",
      detailPageUrl: "",
      eventLocation: "",
      eventsFrom: "",
      eventsTo: "",
    },
  },
};
